import { render, staticRenderFns } from "./verify-mobile.vue?vue&type=template&id=4b0b5276"
import script from "./verify-mobile.vue?vue&type=script&lang=js"
export * from "./verify-mobile.vue?vue&type=script&lang=js"
import style0 from "./verify-mobile.vue?vue&type=style&index=0&id=4b0b5276&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports